import { createContext, useContext } from 'react';

export interface DialogContextValue {
  close: () => void;
}

export const DialogContext = createContext<DialogContextValue | null>(null);

export const useDialogContext = () => {
  const context = useContext(DialogContext);

  if (!context) {
    throw new Error('useDialog must be used inside a <Dialog> provider');
  }

  return context;
};
